import React from 'react';
import { motion } from 'framer-motion';

export const SectionHeading = ({ children, highlight, subtitle }) => {
  return (
    <div className="text-center mb-16 px-4">
      <motion.h2 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight leading-tight"
      >
        {children} {highlight && <span className="text-transparent bg-clip-text bg-gradient-to-r from-royal-400 to-royal-600">{highlight}</span>}
      </motion.h2>
      {subtitle && (
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
};